import { c as create_ssr_component, d as add_attribute, v as validate_component } from "../../chunks/index.js";
import "pixi.js";
const Pixi = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let canvas;
  return `<canvas${add_attribute("width", 32, 0)}${add_attribute("height", 32, 0)}${add_attribute("this", canvas, 0)}></canvas>`;
});
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  return `<h1>Welcome to SvelteKit!</h1>
<p>Visit <a href="${"https://kit.svelte.dev"}">kit.svelte.dev</a> to read the documentation</p>

${validate_component(Pixi, "Pixi").$$render($$result, {}, {}, {})}`;
});
export {
  Page as default
};
